<template>
  <div class="animated fadeIn">
    <template v-if="collection">
      <div v-for="(submission, index) in collection" :key="index">
        <zone-soil-form
          :submission="submission"
          :testPackageSamples="testPackageSamples"
          :addOns="addOns"
          :turnArounds="turnArounds"
          :serviceQuestions="
            sampleType && sampleType.getServiceQuestions()
              ? sampleType.getServiceQuestions()
              : null
          "
          :index="index"
          :key="submission.key"
          :testPackage="testPackage"
          :allTestPackages="allTestPackages"
          @onSubmissionChange="onSubmissionChange"
          @removeSubmission="removeSubmission"
        ></zone-soil-form>
      </div>
    </template>
    <div class="clearfix">
      <b-button class="float-right" variant="success" @click="newSubmission"
        ><i class="fal fa-plus"></i
      ></b-button>
    </div>
  </div>
</template>

<script>
import FieldSoilForm from "./form/FieldSoilForm";
import ZoneSoilForm from "./form/ZoneSoilForm";
import Submission from "../../../models/legacy/Submission";
import TurnaroundCollection from "../../../collections/lab/TurnaroundCollection";
import TestPackageCollection from "../../../collections/lab/TestPackageCollection";
import TestPackageSampleCollection from "../../../collections/lab/TestPackageSampleCollection";

export default {
  name: "SoilSubmissionForm",
  components: { FieldSoilForm, ZoneSoilForm },
  props: {
    submissions: {
      type: Array,
      default: () => []
    },
    testPackageSamples: {
      type: Object,
      default: () => new TestPackageSampleCollection()
    },
    testPackage: {
      type: Object,
      default: () => null
    },
    sampleType: {
      type: Object,
      default: () => null
    },
    addOns: {
      type: Object,
      default: () => new TestPackageCollection()
    },
    turnArounds: {
      type: Object,
      default: () => new TurnaroundCollection()
    },
    allTestPackages: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      collection: [],
      loading: true,
      submission_updating: false
    };
  },
  methods: {
    newSubmission() {
      this.collection = [...this.collection, this.fillSubmission({})];
    },
    fillSubmission(data) {
      data = data || {};

      data = JSON.parse(JSON.stringify(data));
      data.sample_type = this.sampleType
        ? JSON.parse(JSON.stringify(this.sampleType))
        : null;
      data.test_package = this.testPackage
        ? JSON.parse(JSON.stringify(this.testPackage))
        : null;
      data.submission_soil = data.submission_soil || {};
      if (!data.samples || !data.samples.length) {
        data.samples = [];
        this.testPackageSamples.models.forEach(sample => {
          data.samples.push({
            test_package_sample_id: sample.id,
            identifier: sample.name
          });
        });
      }
      if (data.samples && data.samples.length) {
        data.samples.forEach((sample, index) => {
          if (!sample.sample_soil) {
            let start = +index * 6;
            sample.sample_soil = {
              depth_start: start,
              depth_end: start + 6,
              depth_total: 6
            };
          }
          // this.testPackageSamples.models.forEach(testPackageSample => {
          //   if (testPackageSample.id === sample.test_package_sample_id) {
          //     sample.test_package_samples = [];
          //     let temp = JSON.parse(JSON.stringify(testPackageSample));
          //     sample.test_package_samples.push(temp);
          //     if (!sample.identifier) {
          //       sample.identifier = testPackageSample.name;
          //     }
          //   }
          // });
          data.samples[index] = sample;
        });
      }

      if (this.$cookies.get("faker_enabled") === "1") {
        data.submission_soil.grower =
          data.submission_soil.grower || this.$faker().name.findName();
        data.identifier = data.identifier || this.$faker().name.lastName();
        data.event_code =
          data.event_code ||
          data.identifier.replace(/\W/g, "").toUpperCase() +
            "-" +
            new Date().getUTCMilliseconds();
        data.submission_soil.projections = data.submission_soil.projections || [
          {
            crop: null,
            tield: null,
            unit: null
          }
        ];
      }
      return new Submission(data);
    },
    onSubmissionChange(params) {
      if (params && params.submission && params.index !== null) {
        if (!this.loading && !this.submission_updating) {
          this.submission_updating = true;
          this.collection.splice(
            params.index,
            1,
            this.fillSubmission(params.submission)
          );
          this.onSubmissionsChange();
          this.submission_updating = false;
        }
      }
    },
    onSubmissionsChange() {
      this.$emit("onSubmissionsChange", this.collection);
    },
    removeSubmission(index) {
      if (index !== null) {
        this.collection.splice(index, 1);
      }
    }
  },
  mounted() {
    this.loading = true;
    if (!this.submissions.length) {
      this.newSubmission();
    } else {
      this.submissions.forEach(submission => {
        this.collection.push(this.fillSubmission(submission));
      });
    }
    this.$nextTick(() => {
      this.loading = false;
    });
  }
};
</script>
